import { useEffect, useState } from "react";
import { ParentGetSchoolNews } from "services/Parent/ParentServices";
import ParentLoader from "./ParentLoader";
import ParentEmpty from "./ParentEmpty";
import ParentFmt from "./ParentFmt";
import { useAuth } from "context/AuthContext";

const ParentNewsTab = ({studentId}) => {
    const { userInfo } = useAuth();
    const [data, setData] = useState(null);
    useEffect(() => {

        ParentGetSchoolNews(userInfo?.token, Number(studentId)).then(r => setData(r.news)).catch(() => setData([]));

    }, []);



    if (!data) return <ParentLoader />;

    if (data.length === 0) return <ParentEmpty msg="لا توجد أخبار أو إعلانات حالياً" />;



    return (

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

            {data.map(news => (

                <div key={news.id} className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow group flex flex-col h-full">

                    {news.image_path && (

                        <div className="h-48 overflow-hidden relative">

                            <img src={news.image_path} alt={news.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                            {news.notification && (

                                <span className="absolute top-3 right-3 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full animate-pulse shadow-md">هام</span>

                            )}

                        </div>

                    )}

                    <div className="p-6 flex-1 flex flex-col">

                        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 line-clamp-2">{news.title}</h3>

                        <p className="text-gray-800 dark:text-gray-300 font-medium text-sm mb-4 line-clamp-4 flex-1 leading-relaxed">{news.description}</p>

                        <div className="text-sm text-gray-700 dark:text-gray-300 font-bold flex items-center gap-2 mt-auto bg-gray-100 dark:bg-white/10 border border-gray-200 dark:border-white/5 p-2 rounded-lg shadow-sm">

                            <span>📅</span>

                            {ParentFmt(news.date || news.createdAt)}

                        </div>

                    </div>

                </div>

            ))}

        </div>

    );
}

export default ParentNewsTab;